export default __webpack_public_path__ + "static/media/arcgis-urban-launch-kit.67a9d19e.svg";